import {
    type TSessionDialogContext,
    type TSessionDialogDefinition,
} from '../types/sessionDialogTypes'

export const pickSessionDialog = (
    definitions: TSessionDialogDefinition[],
    context: TSessionDialogContext,
): TSessionDialogDefinition | null => {
    const byPriority = [...definitions].sort((a, b) => a.priority - b.priority)

    for (const definition of byPriority) {
        const verdict = definition.shouldShow(context)

        if (verdict === 'pending') {
            return null
        }

        if (verdict) {
            return definition
        }
    }

    return null
}
